export const renderWithoutZero = ({ cell: { value } }) =>
  String(value) === '0' ? '' : value;

export const renderWithoutZeroAndRound = ({ cell: { value } }) =>
  String(value) === '0' ? '' : value.toFixed(2);
